import { CHANGE_CURRENT_LOCALE } from './constants';

import fr from './json/fr';

const initialState = {
    fr
};
const overridedState = {};

export default function reducer(state = initialState.fr, action) {
    switch (action.type) {
        case CHANGE_CURRENT_LOCALE:
            return { ...initialState[action.newState], ...overridedState };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/services/i18n/reducer.js